import React from "react";

import * as Styled from "./styles";

export type OptionButtonProps = {
  text: string;
  onClick: () => void;
};

export const OptionButton: React.FC<OptionButtonProps> = (
  props: OptionButtonProps
): React.JSX.Element => (
  <Styled.OptionButton onClick={props.onClick} data-qa="option:button">
    {props.text}
  </Styled.OptionButton>
);
